/* eslint-disable max-len */

'use client';

import ErrorPage from 'components/Error/Error';
import Error500Logo from 'assets/logos/500.svg';
import Error404Logo from 'assets/logos/404.svg';
import Error400Logo from 'assets/logos/Wrong.svg';

export default function Error({ error }: { error: Error & { digest?: string }}) {
  const isNotFound = error.message.includes('404');
  const isFatalError = error.message.includes('500');

  if (isFatalError) {
    return (
      <ErrorPage
        error={error}
        title="Estamos passando por problemas."
        message="Infelizmente a página não pode ser exibida, aguarde alguns instantes e tente novamente."
        caption="Error interno do servidor. - 500 Internal Server Error."
        image={<Error500Logo width="100%" />}
      />
    );
  }

  if (isNotFound) {
    return (
      <ErrorPage
        error={error}
        title="A página que você procura não foi encontrada"
        message="A página que você procura não foi encontrada"
        caption="Erro 404"
        image={<Error404Logo width="100%" />}
      />
    );
  }

  return (
    <ErrorPage
      error={error}
      title="Erro de requisição"
      message="Ocorreu um erro ao processar a requisição, verifique os dados enviados e tente novamente."
      caption="Requisição com dados inválidos - 400 Bad Request."
      image={(
        <Error400Logo
          width="100%"
          viewBox="0 0 750 600"
          preserveAspectRatio="xMidYMid meet"
        />
        )}
    />
  );
}
